import dateFormat from 'dateformat';
import { unescape as unescapeHTML } from 'html-escaper';

const promotionsData = window.HONDA?.Incentives?.data ?? {};
const page = window.HONDA?.Incentives?.page ?? '';
const globalTooltipTemplate = unescapeHTML(window.HONDA?.Incentives?.tooltipTemplate ?? '');
const globalTooltipFooter = unescapeHTML(window.HONDA?.Incentives?.tooltipFooter ?? '');

const globalBannerTemplate = unescapeHTML(window.HONDA?.Incentives?.bannerTemplate ?? '');
const globalBannerFooter = unescapeHTML(window.HONDA?.Incentives?.bannerFooter ?? '');

const tooltipTemplateMap = {
    'Configurator': 'configuratorTooltipTemplate',
    'Checkout': 'orderSummaryTooltipTemplate',
    'MyAccount': 'orderSummaryTooltipTemplate',
}

const bannerTemplateMap = {
    'Checkout': 'orderSummaryBannerTemplate',
    'MyAccount': 'orderSummaryBannerTemplate',
}

function tooltipTemplate(promotion) {
    const promotionTemplate = unescapeHTML(promotion[tooltipTemplateMap[page]] ?? '');
    return  promotionTemplate || globalTooltipTemplate || ''; 
}

function bannerTemplate(promotion) {
    const bannerTemplate = unescapeHTML(promotion[bannerTemplateMap[page]] ?? '');
    return bannerTemplate || globalBannerTemplate || '';
}

function tooltipContent(promotion) {
    const content = tooltipTemplate(promotion)?.replace(/\${([^}]+)}/g, (ignore, key) =>
        (key = promotion[key]) == null ? '' : key,
    );
    return `<div class="discount-tooltip-row">${content}</div>`;
}

function bannerContent(promotion) {
    const content = bannerTemplate(promotion)?.replace(/\${([^}]+)}/g, (ignore, key) =>
        (key = promotion[key]) == null ? '' : key,
    );
    return `<div class="h--m-b-10">${content}</div>`;
}

export function escapeHTML(str) {
    return str?.replace(
        /[&<>'"]/g,
        (tag) =>
            ({
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                "'": '&#39;',
                '"': '&quot;',
            }[tag]),
    );
}

export function getTooltip(promotions) {
    const content = promotions?.reduce(
        (content, promotion) => (content += promotion ? tooltipContent(promotion) : ''),
        '',
    );
    return content ? `<div class="discount-tooltip-container">${content}${globalTooltipFooter}</div>` : '';
}

export function addTooltips(promotions) {
    promotions?.forEach((promotion) => {
        promotion.tooltip = getTooltip([ promotion ]);
    })
    return promotions;
}

export function getBanner(promotions) {
    const content = promotions
        ?.filter((promotion) => promotion?.isTargetedPromotion)
        ?.reduce((content, promotion) => (content += bannerContent(promotion)), '');
    return content ? `<div class="banner--item">${content}${globalBannerFooter}</div>` : '';
}

export function getPromotionsData(promotions) {
    return promotions
        ?.filter((promotion) => promotion.promotionId)
        ?.map((promotion) => {
            const content = promotionsData[promotion.promotionId];
            return {
                ...content,
                ...promotion,
                ...(content?.name && { name: content.name }),
                ...(promotion.startDate && { startDate: dateFormat(promotion.startDate, 'dS mmm yyyy') }),
                ...(promotion.endDate && { endDate: dateFormat(promotion.endDate, 'dS mmm yyyy') }),
            };
        });
}
